var _circle, _rect, _path, _path2, _rect2, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRealEstateCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Real estate") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#0B2545"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.9,
    y: 4.4,
    width: 1.1,
    height: 2.2,
    fill: "#C0C6CE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6,8.2 L8,4.2 L12.4,8.2",
    fill: "none",
    stroke: "#C0C6CE",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5,8 L8,5.3 L11,8 V11.8 H5 Z",
    fill: "#C0C6CE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.1,
    y: 9.3,
    width: 1.8,
    height: 2.5,
    rx: 0.3,
    fill: "#0B2545"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.85,
    fill: "none",
    stroke: "#000",
    strokeOpacity: 0.12,
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealEstateCircle);
export default __webpack_public_path__ + "static/media/real-estate-circle.9ef714a3430874fce4ae6c295bd7ad43.svg";
export { ForwardRef as ReactComponent };